/**
 * @param roiCalculatorIframe {HTMLIFrameElement}
 * @param data {UngatePayload}
 * @return {void}
 */
module.exports = function dispatchRoiCalculatorUngateEvent(roiCalculatorIframe, data) {
    const roiCalculatorDocument = roiCalculatorIframe.contentWindow.document;

    const event = new CustomEvent("ungate-roi-calculator", {
        detail: {
            data: data,
        }
    });

    roiCalculatorDocument.dispatchEvent(event);
}
